import React, { useState } from 'react';
import { PublicFieldProps, useNotify, useTranslate } from 'react-admin';
import './styles.scss';

type ReportLinkProps = PublicFieldProps & {
  fetchUrl: () => Promise<string>;
  linkText: string;
  errorMessage: string;
};

// Opens a report whose signed URL is minted on click, so the link never goes stale.
// PublicFieldProps carries `label` and `addLabel`, which SimpleShowLayout reads off
// the element to wrap this in <Labeled> the same way it wraps a FileField.
const ReportLink = ({
  fetchUrl,
  linkText,
  errorMessage,
  className,
}: ReportLinkProps) => {
  const notify = useNotify();
  const translate = useTranslate();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);

    // The tab has to be opened synchronously inside the click handler. Opening it
    // after awaiting the request loses the user gesture and browsers block it.
    const tab = window.open('', '_blank');
    if (tab) {
      tab.opener = null;
    }

    try {
      const url = await fetchUrl();
      if (tab) {
        tab.location.href = url;
      }
    } catch (error) {
      tab?.close();
      notify(errorMessage, { type: 'warning' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`reportLink__root ${className || ''}`}>
      <button
        type="button"
        className="reportLink"
        onClick={handleClick}
        disabled={loading}
      >
        {translate(linkText)}
      </button>
    </div>
  );
};

export default ReportLink;
